import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const BusinessCardsBackground = css<{ $image?: string }>`
  background-image: ${({ $image }) => `url('/images/business/${$image}.png')`};
  background-repeat: no-repeat;
  background-position: right 15px top 15px;
  background-size: 85px;
`;

export const BusinessPageCardsItems = styled.div<{
  $image?: string;
}>`
  border-radius: 24px;
  background: ${({ theme }) => theme.palette.secondary.background};
  padding: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 290px;
  height: 170px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 20px 15px;
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: baseline;
    position: relative;
    flex-shrink: 0;
    &:first-of-type {
      margin-left: 40px;
    }
    &:last-of-type {
      margin-right: 40px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 210px;
    height: 140px;

    &:first-of-type {
      margin-left: 15px;
    }
    &:last-of-type {
      margin-right: 15px;
    }
  }

  ${({ $image }) => $image && BusinessCardsBackground}
`;

export const BusinessPageCardsItemsText = styled.div`
  font-size: 26px;
  font-weight: 700;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

export const BusinessPageCardsItemsDescription = styled(Typography.Body)`
  margin-top: 5px;
  font-size: 16px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const BusinessPageCardsSection = styled.section`
  margin: 80px auto;
  max-width: 1280px;
`;

export const BusinessPageCardsTitle = styled(Typography.Header)`
  text-align: center;
  margin-bottom: 60px;
  font-size: 34px;
  font-weight: 700;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 26px;
    margin-bottom: 40px;
  }
`;

export const BusinessPageItems = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${({ theme }) =>
      theme.breakpoints.lg}) and (min-width: 950px) {
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    align-items: center;
    margin: 0;
    border-top-left-radius: 21px;
    border-top-right-radius: 21px;
  }
`;

export const BusinessPageCards = styled.div<{
  $isLite?: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 20px;
  column-gap: 40px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    margin: 0;
    width: 100%;
    max-width: 1300px;
    top: 40px;
    row-gap: 15px;
    column-gap: 15px;
    padding-right: ${({ $isLite }) => ($isLite ? '30px' : '0')};
  }
`;

export const BusinessPageCardsContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 100%;
    position: relative;
    background: none;
  }
`;

export const BusinessPageCardsButton = styled.a`
  display: block;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.system.blue};
  background: ${({ theme }) => theme.palette.primary.background};
  padding: 15px 0;
  width: 100%;
  max-width: 345px;
  margin: 0 auto;
  color: ${({ theme }) => theme.palette.system.blue};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  margin-top: 40px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.palette.system.lightBlue};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: calc(100% - 80px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: calc(100% - 30px);
  }
`;
